import React, { useEffect, useState } from 'react';
import { getAllDevelopmentData, postOverviewAiQuestion } from '../../api';
import { useDevelopmentData } from '../../context/DevelopmentDataContext';
import { useProjectSelection } from '../../context/ProjectSelectionContext';
import { Link } from 'react-router-dom';
//import SlidingAiPanel from '../components/SlidingAiPanel';
import BurndownChart, { BurndownDataset } from '../../components/BurndownChart';
import MetricCard from '../../components/MetricCard';
import { Project } from '../../types/DeveloperTypes';
import { format } from 'date-fns';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartData,
  ChartOptions,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import StaticAiPanel from '../../components/StaticAiPanel';
import LoadingSpinner from '../../components/LoadingSpinner';



ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Project Selector Component
const ProjectSelector: React.FC<{
  projects: any[];
  selectedProjectId: number | null;
  onSelectProject: (projectId: number) => void;
}> = ({ projects, selectedProjectId, onSelectProject }) => {
  const [screenSize, setScreenSize] = useState<'mobile' | 'tablet-portrait' | 'tablet-landscape' | 'desktop'>('desktop');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setScreenSize('mobile');
      } else if (width < 900) {
        setScreenSize('tablet-portrait');
      } else if (width < 1200) {
        setScreenSize('tablet-landscape');
      } else {
        setScreenSize('desktop');
      }
    };

    handleResize(); // Set initial size
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenSize === 'mobile';
  const isTabletPortrait = screenSize === 'tablet-portrait';
  const isTabletLandscape = screenSize === 'tablet-landscape';

  console.log('ProjectSelector - projects:', projects);
  console.log('ProjectSelector - selectedProjectId:', selectedProjectId);

  if (!projects || projects.length === 0) {
    console.log('ProjectSelector - No projects available, not rendering');
    return (
      <div style={{ marginBottom: '1.5rem', color: '#999' }}>
        No projects available
      </div>
    );
  }

  return (
    <div style={{
      marginBottom: isMobile ? '0' : '1.5rem',
      display: 'flex',
      flexDirection: (isMobile || isTabletPortrait) ? 'column' : 'row',
      alignItems: (isMobile || isTabletPortrait) ? 'flex-start' : 'center',
      gap: (isMobile || isTabletPortrait) ? '0.25rem' : '0.5rem',
      width: (isMobile || isTabletPortrait) ? '100%' : 'auto'
    }}>
      <label htmlFor="project-select" style={{
        fontWeight: 500,
        fontSize: (isMobile || isTabletPortrait) ? '0.9rem' : '1rem',
        color: '#333'
      }}>
        Project:
      </label>
      <select
        id="project-select"
        value={selectedProjectId || ''}
        onChange={(e) => onSelectProject(Number(e.target.value))}
        style={{
          padding: (isMobile || isTabletPortrait) ? '0.75rem' : '0.5rem',
          borderRadius: '0.5rem',
          border: '2px solid #e0e0e0',
          backgroundColor: '#fff',
          minWidth: (isMobile || isTabletPortrait) ? '100%' : '200px',
          fontSize: (isMobile || isTabletPortrait) ? '1rem' : '0.9rem',
          fontWeight: '500',
          color: '#333',
          cursor: 'pointer',
          transition: 'border-color 0.2s ease',
          outline: 'none'
        }}
        onFocus={(e) => {
          e.target.style.borderColor = '#3949ab';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = '#e0e0e0';
        }}
      >
        {projects.map((project) => (
          <option key={project.projectId} value={project.projectId}>
            {project.projectName}
          </option>
        ))}
      </select>
    </div>
  );
};

// Main Dashboard Component
const DevelopmentDashboard: React.FC = () => {
  const { hasData, isLoading: isDataCheckLoading } = useDevelopmentData();
  const { selectedProjectId, setSelectedProjectId } = useProjectSelection();
  const [data, setData] = useState<Project | null>(null);
  const [projects, setProjects] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [aiPanelOpen, setAiPanelOpen] = useState<boolean>(false);
  const [aiResponse, setAiResponse] = useState<string>('');
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const [aiError, setAiError] = useState<string | null>(null);
  const [filteredData, setFilteredData] = useState<Project | null>(null);
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const [screenSize, setScreenSize] = useState<'mobile' | 'tablet-portrait' | 'tablet-landscape' | 'desktop'>('desktop');
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

   // Handle window resize for responsive design
    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setScreenSize('mobile');
      } else if (width < 900) {
        setScreenSize('tablet-portrait');
      } else if (width < 1200) {
        setScreenSize('tablet-landscape');
      } else {
        setScreenSize('desktop');
      }
    };

    handleResize(); // Set initial size
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenSize === 'mobile';
  const isTabletPortrait = screenSize === 'tablet-portrait';
  const isTabletLandscape = screenSize === 'tablet-landscape';
  const shouldStack = isMobile || isTabletPortrait;

  // Fetch dashboard data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getAllDevelopmentData();
        console.log('Development Data Response:', response);

        // Debug projects data
        console.log('Projects data:', projects);
        console.log('Selected project ID:', selectedProjectId);

        const dashboardData = response;
        setData(dashboardData);

        // Set projects data
        if (response.projects && response.projects.length > 0) {
          setProjects(response.projects);

          // Set default selected project if not already set
          if (!selectedProjectId && response.projects.length > 0) {
            setSelectedProjectId(response.projects[0].projectId);
          }
          //if selectedproject is null, set it          
          if (!selectedProject) {
            setSelectedProject(response.projects[0]);
          }

        } else if (dashboardData && dashboardData.data && Array.isArray(dashboardData.data)) {
          // Fallback to old structure if needed
          setProjects(dashboardData.data);

          // Set the first project as selected by default
          if (dashboardData.data.length > 0 && !selectedProjectId) {
            setSelectedProjectId(dashboardData.data[0].projectId);
            setSelectedProject(dashboardData.data[0]);
          }
        }

        // Debug log the projects data
        console.log('Extracted projects:', dashboardData?.data || dashboardData?.projects || []);
      } catch (err) {
        setError('Failed to load dashboard data');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedProjectId]);

  // Filter data based on selected project
  useEffect(() => {
    if (!data || !projects.length) {
      setFilteredData(data);
      setSelectedProject(null);
      return;
    }

    // If no project is selected, use the first project
    if (!selectedProjectId) {
      const firstProject = projects[0];
      setSelectedProjectId(firstProject.projectId);
      setSelectedProject(firstProject);
      return;
    }

    // Always find the selected project based on selectedProjectId
    const currentSelectedProject = projects.find(p => p.projectId === selectedProjectId);

    if (!currentSelectedProject) {
      // If selected project doesn't exist, fallback to first project
      const firstProject = projects[0];
      setSelectedProjectId(firstProject.projectId);
      setSelectedProject(firstProject);
      return;
    }

    // Update selectedProject state to match selectedProjectId
    setSelectedProject(currentSelectedProject);

    // Use the selected project's data for filtering
    const filtered = {
      ...data,
      metrics: currentSelectedProject.metrics || {},
      allSprintsBurndownData: currentSelectedProject.allSprintsBurndownData || [],
      throughputTrend: currentSelectedProject.throughputTrend || { labels: [], data: [] },
      topOverEstimateItems: currentSelectedProject.topOverEstimateItems || [],
      aiInsight: currentSelectedProject.aiInsight || '',
      recentIterations: currentSelectedProject.recentIterations || [],
      selectedProject: currentSelectedProject // Add the selected project data for easy access
    };

    setFilteredData(filtered);
  }, [data, selectedProjectId, projects]);

  // Chart options

  const throughputOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {

      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Throughput Trend (Last 5 Sprints)',
        font: {
          size: 16,
          weight: 'bold',
        },
        padding: {
          bottom: 20
        }
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Work Items Completed',
        }
      },
      x: {
        title: {
          display: true,
          text: 'Sprint',
        }
      }
    },
  };

  // Show placeholder message when no development data exists
  if (!isDataCheckLoading && !hasData) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 80px)',
        padding: '2rem'
      }}>
        <div style={{
          maxWidth: '600px',
          background: '#fff',
          borderRadius: '12px',
          padding: '2rem',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          textAlign: 'center'
        }}>
          <div style={{ marginBottom: '1.5rem' }}>
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#3949ab" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 8V12" stroke="#3949ab" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 16H12.01" stroke="#3949ab" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#333' }}>No Development Data Available</h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.5', color: '#666', marginBottom: '1.5rem' }}>
            To view development metrics and insights, you need to set up an integration with your development tools in the Settings page.
          </p>
          <p style={{ fontSize: '1rem', lineHeight: '1.5', color: '#666', marginBottom: '1.5rem' }}>
            After setting up the integration, it can take up to 10 minutes before the data is available in the dashboard.
          </p>
          <Link to="/settings" style={{
            display: 'inline-block',
            background: 'linear-gradient(115deg, rgb(34, 34, 69) 25%, rgb(-77, 182, 159) 162%)',
            color: 'white',
            padding: '0.75rem 1.5rem',
            borderRadius: '4px',
            textDecoration: 'none',
            fontWeight: 500
          }}>
            Go to Settings
          </Link>
        </div>
      </div>
    );
  }

  if (loading) {
    return <LoadingSpinner title="Loading Development Overview..." />;
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 80px)'
      }}>
        <div style={{
          background: '#ffebee',
          color: '#c62828',
          padding: '1rem 2rem',
          borderRadius: 8,
          maxWidth: '500px',
          textAlign: 'center'
        }}>
          <h3>Error Loading Dashboard</h3>
          <p>{error}</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#c62828',
              color: 'white',
              border: 'none',
              padding: '0.5rem 1rem',
              borderRadius: 4,
              cursor: 'pointer'
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!data || !hasData) return null;

  // Use filtered data if available, otherwise use the original data
  const displayData = filteredData || data;

  let dataSnapshotRange = ``;
  if (selectedProject) {
    dataSnapshotRange = `${format(new Date(selectedProject.snapshotStartDate), 'do MMMM yyyy HH:mm')} 
    - ${format(new Date(selectedProject.summaryDate), 'do MMMM yyyy HH:mm')}`;
  }

  const canGenerateAiSummary = (aiGenratedDate: string | undefined): boolean => {
    return aiGenratedDate && selectedProject.summaryDate ? new Date(aiGenratedDate) < new Date(selectedProject.summaryDate) : true;
  };


  // Add null checks for throughput trend data
  const throughputData: ChartData<'bar'> = {
    labels: displayData?.throughputTrend?.labels || [],
    datasets: [
      {
        label: 'Completed Work Items',
        data: displayData?.throughputTrend?.data || [],
        backgroundColor: 'rgba(57, 73, 171, 0.7)',
        borderColor: '#3949ab',
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  // Define color arrays for the bar chart
  const barBackgroundColors = [
    'rgba(57, 73, 171, 0.7)',   // Indigo
    'rgba(0, 150, 136, 0.7)',   // Teal
    'rgba(233, 30, 99, 0.7)',   // Pink
    'rgba(255, 152, 0, 0.7)',   // Orange
    'rgba(156, 39, 176, 0.7)',  // Purple
    'rgba(76, 175, 80, 0.7)',   // Green
    'rgba(33, 150, 243, 0.7)',  // Blue
    'rgba(255, 87, 34, 0.7)'    // Deep Orange
  ];

  const barBorderColors = [
    '#3949ab',   // Indigo
    '#00796b',   // Teal
    '#c2185b',   // Pink
    '#ef6c00',   // Orange
    '#7b1fa2',   // Purple
    '#388e3c',   // Green
    '#1976d2',   // Blue
    '#e64a19'    // Deep Orange
  ];

  return (
    <div style={{      
      margin: '0 auto',
      padding: isMobile ? '0 1rem' : '1rem 1rem',
      paddingBottom: isMobile ? '120px' : '2rem' // Extra space for mobile drawer
    }}>
      {/* Mobile fixed top project selector */}
      {isMobile && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 999,
            paddingTop: 40,
            background: '#ffffff',
            borderBottom: '1px solid #e5e7eb',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
          }}
        >
          <div style={{ maxWidth: 1400, margin: '0 auto', padding: '12px 16px' }}>
            <div style={{
              fontSize: 20,
              fontWeight: 300,
              color: '#374151',
              marginBottom: 8,
              textAlign: 'center',
              fontFamily: 'Raleway, sans-serif'
            }}>
              Development Overview
            </div>
            {projects && projects.length > 0 && (
              <select
                value={selectedProjectId || ''}
                onChange={(e) => setSelectedProjectId(Number(e.target.value))}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  borderRadius: 8,
                  border: '1px solid #d1d5db',
                  background: '#f9fafb',
                  fontSize: 14,
                  color: '#111827'
                }}
              >
                {projects.map((project) => (
                  <option key={project.projectId} value={project.projectId}>
                    {project.projectName}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
      )}
      {/* Spacer to offset fixed header height on mobile */}
      {isMobile && <div style={{ height: 70 }} />}



      {/* Desktop header - hidden on mobile */}
      {!isMobile && (
        <div style={{ 
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexDirection: 'row',
          gap: '1rem'
          
        }}>
          <h1 style={{ 
            margin: 0, 
            fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            lineHeight: '1.2',
            wordBreak: 'break-word',
            maxWidth: '100%',
            overflow: 'hidden',
            fontFamily: 'Raleway, sans-serif',
            fontWeight: 300,
          }}>{`Development Overview (${selectedProject?.projectName})`}</h1>
          
          <ProjectSelector 
            projects={projects} 
            selectedProjectId={selectedProjectId} 
            onSelectProject={setSelectedProjectId}             
          />
        </div>
      )}

      {/* Data Snapshot */}
      <div style={{ marginBottom: '2rem' }}>
        {selectedProject?.summaryDate && (
          <p className="dashboard-subtitle" style={{
            marginBottom: '2rem',
            color: '#666',
            fontSize: isMobile ? '0.8rem' : '0.9rem'
          }}>
            Data snapshot: {dataSnapshotRange}
          </p>
        )}
      </div>

      {/* Layout container - responsive */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr',
        gap: '1rem'
      }}>
        {/* Left Column - Charts (AI Panel moved to drawer on mobile) */}
        <div>
          {/* AI Insight Panel - Desktop only */}
          {!isMobile && (
            <div style={{
              height: '550px',
              marginBottom: '3rem'
            }}>
              <StaticAiPanel
                insight={selectedProject?.aiInsight?.summary}
                entityName={selectedProject?.projectName}
                contextType="project"
                entityId={selectedProject?.projectId?.toString()}
                projectId={selectedProject?.projectId?.toString()}
                createdOn={selectedProject?.aiInsight?.createdOn ? selectedProject.aiInsight.createdOn : undefined}
                canGenerate={canGenerateAiSummary(selectedProject?.aiInsight?.createdOn)}
              />
            </div>
          )}

          {/* Charts Row - Responsive layout */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: shouldStack ? '1fr' : isTabletLandscape ? '1fr 1fr' : '2fr 1fr',
            gap: '1rem',
            marginTop: shouldStack ? '0' : '3rem'
          }}>
            {/* Sprint Burndown Chart */}
            <div style={{
              background: '#fff',
              borderRadius: 12,
              padding: shouldStack ? '1rem' : '1.5rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              marginBottom: shouldStack ? '1rem' : '0',
              minWidth: 0 // Prevent grid item from overflowing
            }}>
              <h2 style={{ fontSize: shouldStack ? '1.2rem' : '1.5rem', marginBottom: '1rem' }}>Sprint Burndown</h2>
              <BurndownChart
                burndownDatasets={selectedProject?.allSprintsBurndownData || []}
                title=""
                height={shouldStack ? 320 : 350}
              />
            </div>

            {/* Throughput Chart */}
            <div style={{
              background: '#fff',
              borderRadius: 12,
              padding: shouldStack ? '1rem' : '1.5rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              minWidth: 0, // Prevent grid item from overflowing
              overflow: 'hidden'
            }}>
              <h2 style={{ fontSize: shouldStack ? '1.2rem' : '1.5rem', marginBottom: '1rem' }}>Team Throughput</h2>
              <div style={{ height: shouldStack ? '250px' : '350px', position: 'relative' }}>
                <Bar
                  options={{
                    ...throughputOptions,
                    maintainAspectRatio: false,
                    responsive: true,
                  }}
                  data={{
                    labels: throughputData.labels,
                    datasets: [{
                      ...throughputData.datasets[0],
                      backgroundColor: (throughputData.labels || []).map((_, index) =>
                        barBackgroundColors[index % barBackgroundColors.length]
                      ),
                      borderColor: (throughputData.labels || []).map((_, index) =>
                        barBorderColors[index % barBorderColors.length]
                      )
                    }]
                  }}
                />
              </div>
            </div>
          </div>
        </div>



        {/* Right Column - Metric Cards */}
        <div style={{ marginTop: isMobile ? '2rem' : '0' }}>
          {/* Good Trends Section */}
          <h2 style={{
            marginBottom: '1rem',
            marginTop: '0',
            fontSize: isMobile ? '1.2rem' : '1.5rem',
            color: '#4caf50',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4caf50" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
              <path d="M22 4L12 14.01l-3-3" />
            </svg>
            Recent Positive Trends
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1rem',
            marginBottom: '0'
          }}>
            {/* Dynamically render cards with good trends */}
            {displayData?.metrics && Object.entries(displayData.metrics)
              .filter(([_, metric]: [string, any]) => metric?.isGoodTrend === true)
              .map(([key, metric]: [string, any]) => {
                // Determine which metric to render based on the key
                switch (key) {
                  case 'openBugs':
                    return (
                      <MetricCard
                        key={key}
                        title="Open Bugs"
                        value={metric.value || 0}
                        description="Active bugs across all sprints"
                        frontValueColor="#4caf50"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f44336" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <path d="M15 9l-6 6M9 9l6 6" />
                        </svg>}
                        isNegative={true}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'velocityPercentage':
                    return (
                      <MetricCard
                        key={key}
                        title="Velocity Percentage"
                        value={`${Math.round(metric.value || 0)}%`}
                        description="Completed story points vs planned"
                        frontValueColor="#4caf50"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff9800" strokeWidth="2">
                          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'avgPRReviewTime':
                    return (
                      <MetricCard
                        key={key}
                        title="Average PR Review Time"
                        value={`${Math.round((metric.value || 0) * 10 + Number.EPSILON) / 10} hours`}
                        description="Average time to review pull requests"
                        frontValueColor="#4caf50"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2196f3" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 6v6l4 2" />
                        </svg>}
                        isNegative={true}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round((metric.difference || 0) * 10 + Number.EPSILON) / 10} hours from last sprint`}
                      />
                    );
                  case 'completedStories':
                    return (
                      <MetricCard
                        key={key}
                        title="Completed User Stories"
                        value={metric.value || 0}
                        description="Stories completed in last sprint"
                        frontValueColor="#4caf50"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2196f3" strokeWidth="2">
                          <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                          <path d="M22 4L12 14.01l-3-3" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'sprintGoalAchievement':
                    return (
                      <MetricCard
                        key={key}
                        title="Sprint Goal Achievement"
                        value={`${Math.round(metric.value || 0)}%`}
                        description="Percentage of planned work completed"
                        frontValueColor="#4caf50"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4caf50" strokeWidth="2">
                          <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                          <path d="M22 4L12 14.01l-3-3" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'averageProductivity':
                    return (
                      <MetricCard
                        key={key}
                        title="Average Developer Productivity"
                        value={`${metric.value?.toFixed(1) || '0.0'}%`}
                        description="Team productivity score (0-100 scale)"
                        frontValueColor="#4caf50"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#9c27b0" strokeWidth="2">
                          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'velocity':
                    return (
                      <MetricCard
                        key={key}
                        title="Team Velocity"
                        value={metric.value || 0}
                        description="Total story points completed in last sprint"
                        frontValueColor="#4caf50"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00bcd4" strokeWidth="2">
                          <path d="M18 6L6 18M6 6l12 12" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'itemsOverEstimate':
                    return (
                      <MetricCard
                        key={key}
                        title="Items Exceeding Estimates"
                        value={metric.value || 0}
                        description="Work items that took longer than estimated"
                        frontValueColor="#4caf50"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f44336" strokeWidth="2">
                          <path d="M12 5v14M5 12h14" />
                        </svg>}
                        isNegative={true}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.abs(Math.round(metric.trend || 0))}% from last sprint`}
                      />
                    );
                  case 'itemsUnderEstimate':
                    return (
                      <MetricCard
                        key={key}
                        title="Items Delivered Early"
                        value={metric.value || 0}
                        description="Work items completed faster than estimated"
                        frontValueColor="#4caf50"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4caf50" strokeWidth="2">
                          <path d="M5 12h14" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.abs(Math.round(metric.trend || 0))}% from last sprint`}
                      />
                    );
                  default:
                    return null;
                }
              })
            }
          </div>

          {/* Bad Trends Section */}
          <h2 style={{
            marginBottom: '1rem',
            fontSize: isMobile ? '1.2rem' : '1.5rem',
            color: '#f44336',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f44336" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M15 9l-6 6M9 9l6 6" />
            </svg>
            Recent Concerning Trends
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1rem'
          }}>
            {/* Dynamically render cards with bad trends */}
            {displayData?.metrics && Object.entries(displayData.metrics)
              .filter(([_, metric]: [string, any]) => metric?.isGoodTrend === false)
              .map(([key, metric]: [string, any]) => {
                // Determine which metric to render based on the key
                switch (key) {
                  case 'openBugs':
                    return (
                      <MetricCard
                        key={key}
                        title="Open Bugs"
                        value={metric.value || 0}
                        description="Active bugs across all sprints"
                        frontValueColor="#f44336"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f44336" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <path d="M15 9l-6 6M9 9l6 6" />
                        </svg>}
                        isNegative={true}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'velocityPercentage':
                    return (
                      <MetricCard
                        key={key}
                        title="Velocity Percentage"
                        value={`${Math.round(metric.value || 0)}%`}
                        description="Completed story points vs planned"
                        frontValueColor="#f44336"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff9800" strokeWidth="2">
                          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'avgPRReviewTime':
                    return (
                      <MetricCard
                        key={key}
                        title="Average PR Review Time"
                        value={`${Math.round((metric.value || 0) * 10 + Number.EPSILON) / 10} hours`}
                        description="Average time to review pull requests"
                        frontValueColor="#f44336"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2196f3" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 6v6l4 2" />
                        </svg>}
                        isNegative={true}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round((metric.difference || 0) * 10 + Number.EPSILON) / 10} hours from last sprint`}
                      />
                    );
                  case 'completedStories':
                    return (
                      <MetricCard
                        key={key}
                        title="Completed User Stories"
                        value={metric.value || 0}
                        description="Stories completed in last sprint"
                        frontValueColor="#f44336"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2196f3" strokeWidth="2">
                          <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                          <path d="M22 4L12 14.01l-3-3" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'sprintGoalAchievement':
                    return (
                      <MetricCard
                        key={key}
                        title="Sprint Goal Achievement"
                        value={`${Math.round(metric.value || 0)}%`}
                        description="Percentage of planned work completed"
                        frontValueColor="#f44336"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4caf50" strokeWidth="2">
                          <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                          <path d="M22 4L12 14.01l-3-3" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'averageProductivity':
                    return (
                      <MetricCard
                        key={key}
                        title="Average Developer Productivity"
                        value={`${metric.value?.toFixed(1) || '0.0'}%`}
                        description="Team productivity score (0-100 scale)"
                        frontValueColor="#f44336"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#9c27b0" strokeWidth="2">
                          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'velocity':
                    return (
                      <MetricCard
                        key={key}
                        title="Team Velocity"
                        value={metric.value || 0}
                        description="Total story points completed in last sprint"
                        frontValueColor="#f44336"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00bcd4" strokeWidth="2">
                          <path d="M18 6L6 18M6 6l12 12" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.round(metric.trend || 0)}% from last sprint`}
                      />
                    );
                  case 'itemsOverEstimate':
                    return (
                      <MetricCard
                        key={key}
                        title="Items Exceeding Estimates"
                        value={metric.value || 0}
                        description="Work items that took longer than estimated"
                        frontValueColor="#f44336"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f44336" strokeWidth="2">
                          <path d="M12 5v14M5 12h14" />
                        </svg>}
                        isNegative={true}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.abs(Math.round(metric.trend || 0))}% from last sprint`}
                      />
                    );
                  case 'itemsUnderEstimate':
                    return (
                      <MetricCard
                        key={key}
                        title="Items Delivered Early"
                        value={metric.value || 0}
                        description="Work items completed faster than estimated"
                        frontValueColor="#f44336"
                        icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4caf50" strokeWidth="2">
                          <path d="M5 12h14" />
                        </svg>}
                        trend={(metric.trend || 0) > 0 ? "up" : "down"}
                        trendValue={`${Math.abs(Math.round(metric.trend || 0))}% from last sprint`}
                      />
                    );
                  default:
                    return null;
                }
              })
            }
          </div>
        </div>


      </div>

      {/* Mobile AI Drawer */}
      {isMobile && (
        <>
          {/* Drawer Handle */}
          <div
            onClick={() => setDrawerOpen(!drawerOpen)}
            style={{
              position: 'fixed',
              bottom: drawerOpen ? '76vh' : '0',
              left: '0',
              right: '0',
              height: '60px',
              background: 'linear-gradient(115deg, rgb(34, 34, 69) 25%, rgb(77, 182, 159) 162%)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              transition: 'bottom 0.3s ease-in-out',
              borderTopLeftRadius: drawerOpen ? '0' : '20px',
              borderTopRightRadius: drawerOpen ? '0' : '20px',
              boxShadow: '0 -4px 20px rgba(0,0,0,0.15)'
            }}
          >
            <div style={{
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '1rem',
              fontWeight: '500'
            }}>
              <span>Exec Project Insights</span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                style={{
                  transform: drawerOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              >
                <path d="M18 15l-6-6-6 6" />
              </svg>
            </div>
          </div>

          {/* Drawer Content */}
          <div
            style={{
              position: 'fixed',
              bottom: drawerOpen ? '0' : '-76vh',
              left: '0',
              right: '0',
              height: '76vh',
              background: 'white',
              zIndex: 999,
              transition: 'bottom 0.3s ease-in-out',
              paddingBottom: '2rem',
              //borderTopLeftRadius: '20px',
              //borderTopRightRadius: '20px',
              //boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
              overflow: 'hidden'
            }}
          >
            <div style={{
              height: '100%',
              padding: '1rem',
              paddingTop: '2rem',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <StaticAiPanel
                insight={selectedProject?.aiInsight?.summary}
                entityName={selectedProject?.projectName}
                contextType="project"
                entityId={selectedProject?.projectId?.toString()}
                projectId={selectedProject?.projectId?.toString()}
                createdOn={selectedProject?.aiInsight?.createdOn ? selectedProject.aiInsight.createdOn : undefined}
                canGenerate={canGenerateAiSummary(selectedProject?.aiInsight?.createdOn)}
              />
            </div>
          </div>

          {/* Overlay */}
          {drawerOpen && (
            <div
              onClick={() => setDrawerOpen(false)}
              style={{
                position: 'fixed',
                top: '0',
                left: '0',
                right: '0',
                bottom: '76vh',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                zIndex: 998,
                transition: 'opacity 0.3s ease-in-out'
              }}
            />
          )}
        </>
      )}

    </div>
  );
};

export default DevelopmentDashboard;
